import { pick, prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { languageService } from 'js/services/language.service';
import { useGetTemporaryAuthenticationToken } from 'js/hooks/auth';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as actions from 'js/components/system/CommunicationWidgets/store/actions';
import { useIsWidgetsEnabled } from 'js/components/system/CommunicationWidgets/hooks/useInitWidgets/hooks/useIsWidgetsEnabled';
import { useCheckUrlAfterDeposit } from '@theme/js/hooks/swiss/deposit/hooks/useCheckUrlAfterDeposit';

export const useLogin = () => {
    const { isLoggedIn, lang, userName } = useUserSelector(pick(['lang', 'isLoggedIn', 'userName']));
    const { casinoName, clientType, clientVersion } = useAppSelector(
        pick(['casinoName', 'clientType', 'clientVersion']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationToken();
    const { enableInbox } = useIsWidgetsEnabled();
    const dispatch = useDispatch();
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));
    const checkUrlAfterDeposit = useCheckUrlAfterDeposit();

    return useCallback(() => {
        if (!isLoggedIn || !window.Communication) {
            return;
        }

        (async () => {

            try {
                const temporaryToken = await getTemporaryAuthenticationToken();

                await window.Communication.API.common.loginByToken({
                    userName,
                    casinoName,
                    clientType,
                    clientVersion,
                    realMode: 1,
                    sessionToken: temporaryToken,
                    languageCode: languageService.convertToIMS(lang),
                    clientPlatform,
                    deliveryPlatform: 'Hub2'
                });

                checkUrlAfterDeposit();
                enableInbox && await window.Communication.API.inbox.subscribe();
                dispatch(actions.setIsWidgetsAuthenticated(true));
            } catch (error) {
                console.error(error, 'error');
            }
        })();
    }, [
        checkUrlAfterDeposit,
        isLoggedIn, lang, userName,
        casinoName, clientType, clientVersion, enableInbox,
        getTemporaryAuthenticationToken, clientPlatform, dispatch
    ]);
};
